import _ from "lodash";
import { amount } from "@/filters";

export const ASIN_ENUMS = [{
    id: '1',
    text: '子ASIN'
}, {
    id: '2',
    text: '父ASIN'
}]

export const DATE_ENUMS  = [{
    id: '1',
    text: '日期'
}, {
    id: '2',
    text: '月份'
}]

export const COMPARE_ENUMS = [{
    id: '1',
    text: '时间对比'
}, {
    id: '2',
    text: '指标对比'
}]


export const DATA_CHARTS = {
    ring: {
        name: '简单环图',
        data: {
            columns: ['日期', '余额', '年龄'],
            rows: [
                { '日期': '1-1', '余额': 123, '年龄': 3 },
                { '日期': '1-2', '余额': 1223, '年龄': 6 },
                { '日期': '1-3', '余额': 2123, '年龄': 9 },
                { '日期': '1-4', '余额': 4123, '年龄': 12 },
                { '日期': '1-5', '余额': 3123, '年龄': 15 },
                { '日期': '1-6', '余额': 7123, '年龄': 20 }
            ]
        },
        settings: {}
    },
    line: {
        name: '简单折线图',
        data: {
            columns: ['日期', '余额', '年龄'],
            rows: [
                { '日期': '1-1', '余额': '1213', '年龄': 3 },
                { '日期': '1-2', '余额': 1223, '年龄': 6 },
                { '日期': '1-3', '余额': 2123, '年龄': 9 },
                { '日期': '1-4', '余额': 4123, '年龄': 12 },
                { '日期': '1-5', '余额': 3123, '年龄': 15 },
                { '日期': '1-6', '余额': 7123, '年龄': 20 }
            ]
        },
        settings: {}
    },
    histogram: {
        name: '简单柱状图',
        data: {
            columns: ['日期', '余额', '年龄'],
            rows: [
                { '日期': '1-1', '余额': 123, '年龄': 3 },
                { '日期': '1-2', '余额': 1223, '年龄': 6 },
                { '日期': '1-3', '余额': 2123, '年龄': 9 },
                { '日期': '1-4', '余额': 4123, '年龄': 12 },
                { '日期': '1-5', '余额': 3123, '年龄': 15 },
                { '日期': '1-6', '余额': 7123, '年龄': 20 }
            ]
        },
        settings: {}
    },
    scatter: {
        name: '简单散点图',
        data: {
            columns: ['日期', '余额', '数量', '年龄'],
            rows: {
                '上海': [
                    { '日期': '1-1', '余额': 123, '年龄': 3, '数量': 1244 },
                    { '日期': '1-2', '余额': 1223, '年龄': 6, '数量': 2344 },
                    { '日期': '1-3', '余额': 7123, '年龄': 9, '数量': 3245 },
                    { '日期': '1-4', '余额': 4123, '年龄': 12, '数量': 4355 },
                    { '日期': '1-5', '余额': 3123, '年龄': 15, '数量': 4564 },
                    { '日期': '1-6', '余额': 2323, '年龄': 20, '数量': 6537 }
                ],
                '北京': [
                    { '日期': '1-1', '余额': 123, '年龄': 3, '数量': 1244 },
                    { '日期': '1-2', '余额': 1273, '年龄': 6, '数量': 2344 },
                    { '日期': '1-3', '余额': 3123, '年龄': 15, '数量': 4564 },
                    { '日期': '1-4', '余额': 2123, '年龄': 9, '数量': 3245 },
                    { '日期': '1-5', '余额': 4103, '年龄': 12, '数量': 4355 },
                    { '日期': '1-6', '余额': 7123, '年龄': 10, '数量': 3567 }
                ],
                '广州': [
                    { '日期': '1-1', '余额': 123, '年龄': 3, '数量': 1244 },
                    { '日期': '1-2', '余额': 1223, '年龄': 6, '数量': 2344 },
                    { '日期': '1-3', '余额': 2123, '年龄': 30, '数量': 3245 },
                    { '日期': '1-5', '余额': 4123, '年龄': 12, '数量': 4355 },
                    { '日期': '1-4', '余额': 5123, '年龄': 18, '数量': 4564 },
                    { '日期': '1-6', '余额': 3843, '年龄': 30, '数量': 4850 }
                ]
            }
        },
        settings: {}
    }
}

export const DATA_TABLE_COLUMN = [
    {id: 'campaignName', header: '广告活动', field: 'campaignName', minWidth: '120px'},
    {id: 'impressions', header: '点击量', field: 'impressions', minWidth: '120px'},
    {id: 'quantityAfterPay', header: 'CTR', field: 'quantityAfterPay', minWidth: '120px'},
    {id: 'type', header: 'ACOS', field: 'option:type', minWidth: '120px', options: []},
    {id: 'userName', header: '运营状态变化趋势', field: 'userName', minWidth: '120px'}
]

export const AD_TABLE_COLUMN = [
    {id: 'clicks', header: '曝光量', field: 'slot:clicks', minWidth: '120px', align: 'right'},
    {id: 'ctr', header: 'CVR', field: 'slot:ctr', minWidth: '120px', align: 'right'},
    {id: 'acos', header: 'ACOS', field: 'slot:acos', minWidth: '120px', align: 'right'}
]

export const COMMENT_TABLE_COLUMN = [
    {id: 'date', header: '日期', field: 'date', minWidth: '120px'},
    {id: 'star', header: '评分', field: 'star', minWidth: '60px', align: 'right'},
    {id: 'fiveStar', header: '5星数', field: 'fiveStar', minWidth: '60px', align: 'right'},
    {id: 'fourStar', header: '4星数', field: 'fourStar', minWidth: '60px', align: 'right'},
    {id: 'threeStar', header: '3星数', field: 'threeStar', minWidth: '60px', align: 'right'},
    {id: 'twoStar', header: '2星数', field: 'twoStar', minWidth: '60px', align: 'right'},
    {id: 'oneStar', header: '1星数', field: 'oneStar', minWidth: '60px', align: 'right'}
]

export const REVIEW_TABLE_COLUMN = (vm) => [
    {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '150px', fixed: 'left', default: true, options: () => vm.marketOption, disabled: true},
    {id: 'star', header: '星级', field: 'slot:star', width: '150px'},
    {id: 'content', header: '评论内容', field: 'slot:reviewContent', minWidth: '200px'},
    {id: 'amazonUserName', header: '评论用户', field: 'slot:amazonUserName', minWidth: '120px'},
    {id: 'reviewDate', header: '评论日期', field: 'reviewDate', width: '150px'},
    {id: 'orderIds', header: '订单编号', field: 'slot:orderIds', minWidth: '120px'},
    {id: 'reviewId', header: '评论编码', field: 'reviewId', minWidth: '120px'},
    {id: 'status', header: '状态', field: 'slot:status', minWidth: '120px'},
    {id: 'op', header: '操作', field: 'slot:op', width: '120px'}
]

export const WORD_CLOUD_TABLE_COLUMN = [
    {id: 'ranking', header: '排名', field: 'ranking', minWidth: '60px'},
    {id: 'word', header: '词云关键词', field: 'word', minWidth: '120px'},
    {id: 'count', header: '出现频次', field: 'count', minWidth: '80px'},
]

const sliceArr = (arr, count) =>{
    return arr.reduce((sum, item, index, arr) => {
        const curStep = arr.slice(sum.length * count, (sum.length + 1) * count);
        if (curStep.length) {
            sum.push(curStep);
        }
        return sum;
    }, [])
}

export const generatorLineTimeCompareToolTip = (showPercentColumn, showCurrencySymbol, labelMap, currencySymbol, statisticsData, thenData, operationLogVOList) => {
    return items => {
        let tpl = []
        const { name, axisValueLabel } = items[0]
        const title = name || axisValueLabel
        tpl.push(`${title}<br>`)
        items.forEach(({ seriesName, data, marker, name }, i) => {
            const itemData = Array.isArray(data) ? data[1] : data
            const prefix = showCurrencySymbol.length ? currencySymbol : ''
            const suffix = showPercentColumn.length ? '%' : ''
            const dateLineIndex = statisticsData.findIndex(v => v.dateLine === name)
            const thenDateLine = dateLineIndex >= 0 ? thenData[dateLineIndex]['dateLine'] : name
            tpl.push(marker)
            tpl.push(`${seriesName}: ${seriesName === '统计时间' ? name : thenDateLine} ${prefix}${(prefix ? amount(itemData) : itemData) || 0}${suffix}`)
            tpl.push('<br>')
        })

        if (operationLogVOList && operationLogVOList.length) {
            const log = operationLogVOList.filter(v => v.logDate === name)
            if (log && log.length) {
                tpl.push('运营日志')
                tpl.push('<br>')
                log.forEach(v => {
                    let { type = '', content = '' } = v
                    content = type ? `${type}:${content}` : content
                    if (content.length > 30) {
                        const contentArr = content.split('')
                        const slice = sliceArr(contentArr, 30)

                        if (slice) {
                            slice && slice.length && slice.forEach(v => {
                                tpl.push(v.join(''))
                                tpl.push('<br>')
                            })
                        }
                    } else {
                        tpl.push(content)
                    }
                    tpl.push('<br>')
                })

            }
        }
        return tpl.join('')
    }
}


export const generatorToolTip = (showPercentColumn, showCurrencySymbol, labelMap, currencySymbol, operationLogVOList) => {
    return items => {
        let tpl = []
        const { name, axisValueLabel } = items[0]
        const title = name || axisValueLabel
        tpl.push(`${title}<br>`)
        items.forEach(({ seriesName, data, marker }, i) => {
            let itemData = Array.isArray(data) ? data[1] : data
            tpl.push(marker)
            let seriesKey = ''
            for (let key in labelMap) {
                if (labelMap[key] === seriesName) {
                    seriesKey = key
                    break;
                }
            }
            if (seriesKey) {
                let suffix = showPercentColumn.includes(seriesKey) ? '%' : ''
                let prefix = showCurrencySymbol.includes(seriesKey) ? currencySymbol : ''
                itemData = showPercentColumn.includes(seriesKey) ? (itemData * 100).toFixed(2) : itemData
                tpl.push(`${seriesName}: ${ prefix || ''}${itemData || 0}${ suffix || ''}`)
            } else {
                tpl.push(`${seriesName}: ${itemData || 0}`)
            }
            tpl.push('<br>')
        })

        if (operationLogVOList && operationLogVOList.length) {
            const log = operationLogVOList.filter(v => v.logDate === name)
            if (log && log.length) {
                tpl.push('运营日志')
                tpl.push('<br>')
                log.forEach(v => {
                    let { type = '', content = '' } = v
                    content = type ? `${type}:${content}` : content
                    if (content.length > 30) {
                        const contentArr = content.split('')
                        const slice = sliceArr(contentArr, 30)

                        if (slice) {
                            slice && slice.length && slice.forEach(v => {
                                tpl.push(v.join(''))
                                tpl.push('<br>')
                            })
                        }
                    } else {
                        tpl.push(content)
                    }
                    tpl.push('<br>')
                })

            }
        }

        return tpl.join('')
    }
}

export const generatorLineChartsData = () => {
    return {
        color: ["rgb(0, 153, 255)", "rgb(81, 211, 81)", '#F3667C','#46A1FF','#89D1EA','#4DCBCB','#85DFBE','#5ACB74','#ACDF84','#FAD54C','#FAF357','#EAA775'],
        tooltip: {
            trigger: 'axis',
            // formatter: `{a0}: {c0}<br />{a1}: {c1}`,
            position: function(point, params, dom, rect, size) {
                if (point[0] + size.contentSize[0] + 30 > size.viewSize[0]) {
                    return [point[0] - size.contentSize[0] - 30, '15%'];
                }
                return [point[0] + 20, '15%'];
            },
        },
        legend: {
            type: 'scroll',
            itemGap: 50,
            icon: "rect",
            itemWidth: 15,
            itemHeight: 3,
            textStyle: {
                color: '#888',
                padding: [2, 0, 0, 0],
            }
        },
        grid: {
            top: '10%',
            // left: '2%',
            // right: '2%',
            bottom: '0%',
            containLabel: true
        },
        xAxis: {
            axisLabel: {
                color: "#32393d"
            },
            axisLine: {
                lineStyle: {
                    color: "#32393d"
                }
            },
        },
        series: {
            smooth: false
        }
    }
}


export const generatorScatterChartsData = (params = {}) => {
    return {
        color: ['rgba(165, 200, 255, .8)'],
        grid: {
            show: true,
            top: '15%',
            left: '2%',
            right: '15%',
            bottom: '2%',
            containLabel: true
        },
        textStyle: {
            fontSize: 12
        },
        xAxis: {
            type: 'value',
            min: 0,
            max: params.maxX,
            splitNumber: 4,
            interval: params.maxX / 4,
            axisLabel: {
                formatter (value) {
                    return `${value}%`
                }
            }
        },
        yAxis: {
            type: 'value',
            min: 0,
            max: params.maxY,
            splitNumber: 4,
            interval: params.maxY / 4,
        },
    }
}

export const generatorSalesRankingChartData = (statisticsData = [], thanData = [], maxRank) => {
    return {
        legend: {
            top: '0%',
            itemGap: 10,
            icon: "rect",
            itemWidth: 15,
            itemHeight: 3,
            textStyle: {
                color: '#888',
                padding: [2, 0, 0, 0],
            }
        },
        grid: {
            top: '40px',
            bottom: '0%',
            containLabel: true
        },
        yAxis: {
            inverse: true,
        },
        tooltip: {
            trigger: 'axis',
            renderMode: 'html',
            textStyle: {
                color: '#ffffff',
                ellipsis: '...'
            },
            padding: 10,
            formatter(params) {
                let [ param = {} ] = params
                let { dataIndex = 0 } = param
                let rankingItem = statisticsData[dataIndex] || {}
                let thanItem = thanData[dataIndex] || {}

                return `
                    <div style="width: 230px; height: 100px;color: #fff;">
                        <div style="display: flex;justify-content: space-between">
                            <span style="text-align: left">${rankingItem.dateLine}</span>
                            <span>排名</span>
                        </div>
                        <div style="display: flex;justify-content: space-between">
                            <span style="text-align: left">${rankingItem.mainSellerCategory || '-'}</span>
                            <span>${rankingItem.mainSellerRank || '-'}</span>
                        </div>
                         <div style="display: flex;justify-content: space-between">
                            <span style="text-align: left">${rankingItem.sellerCategory || '-'}</span>
                            <span>${rankingItem.sellerRank || '-'}</span>
                        </div>
                        <div style="display: flex;justify-content: space-between">
                            <span style="text-align: left">上一周期同日：${thanItem.dateLine}</span>
                            <span>排名</span>
                        </div>
                        <div style="display: flex;justify-content: space-between">
                            <span style="text-align: left">${thanItem.mainSellerCategory || '-'}</span>
                            <span>${thanItem.mainSellerRank || '-'}</span>
                        </div>
                        <div style="display: flex;justify-content: space-between">
                            <span style="text-align: left">${thanItem.sellerCategory || '-'}</span>
                            <span>${thanItem.sellerRank || '-'}</span>
                        </div>
                    </div>
                `
            }
        }
    }
}

export const generatorBarChartsData = (currencySymbol) => {
    return {
        color: ['#1F6EEF', '#31E26C', '#CDDDFD'],
        legend: {
            top: '5px',
            itemGap: 10,
            icon: "rect",
            itemWidth: 15,
            itemHeight: 3,
            textStyle: {
                color: '#888',
                padding: [2, 0, 0, 0],
            }
        },
        tooltip: {
            trigger: 'axis',
            formatter:function(params){
            let str = '';
            params.map((v,idx)=>{
              if(idx === 0 ){
                str += v.name + "<br/>";
              }
              if ([0, 1].includes(idx)) {
                str += v.marker + v.seriesName + ":&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + currencySymbol + amount(v.value) + "<br/>"
              }else {
                str += v.marker + v.seriesName + ":&nbsp;&nbsp;" + currencySymbol + amount(v.value) + "<br/>"
              }
            });
            return str;
          }
        },
        grid: {
            top: '40px',
            left: '10px',
            right: '10px',
            bottom: '10px',
            containLabel: true
        },
        series: {
            barMaxWidth: 30
        }
    }
}

export const generatorPieTwoChartsData = (currencySymbol) => {
    return data => {
        return {
            tooltip: {
                formatter:function(params){
                    let str = '金额' + "<br/>";
                    str += params.marker + params.data.name + ":&nbsp;&nbsp;" + currencySymbol + amount(params.data.value)
                    return str;
                }
            },
            title: {
                text: '{header1| 费用项}' +
                    '{header2| 平均费用}' +
                    '{header3| 费用}' +
                    '{header4| 费用占比}',
                textAlign: 'left',
                left: '41%',
                top: '0%',
                textStyle: {
                    // color: '#ccc',
                    rich: {
                        header1: {
                            width: 90,
                            fontSize: 14
                        },
                        header2: {
                            width: 85,
                            fontSize: 14
                        },
                        header3: {
                            width: 60,
                            fontSize: 14
                        },
                        header4: {
                            fontSize: 14
                        }
                    }
                }
            },
            legend: {
                // selectedMode: false, // 取消图例上的点击事件
                type: 'plain',
                icon: 'circle',
                orient: 'vertical',
                left: '40%',
                top: '10%',
                align: 'left',
                itemGap: 15,
                itemWidth: 10, // 设置宽度
                itemHeight: 10, // 设置高度
                symbolKeepAspect: false,
                textStyle: {
                    color: '#000',
                    rich: {
                        name: {
                            verticalAlign: 'right',
                            align: 'left',
                            width: 90,
                            fontSize: 12
                        },
                        value: {
                            align: 'left',
                            width: 60,
                            fontSize: 12
                        },
                        count: {
                            align: 'left',
                            width: 70,
                            fontSize: 12
                        },
                        upRate: {
                            align: 'left',
                            width:50,
                            fontSize: 12,

                        },
                        downRate: {
                            align: 'left',
                            fontSize: 12,

                        }
                    }
                },
                tooltip:{
                    show: true,
                    formatter: (params) => {
                        let name = params.name;
                        let tooltipStr = "";
                        switch (name) {
                            case "采购成本":
                                tooltipStr = "销售订单中所产生的采购成本，<br/>不包含多渠道订单采购成本";
                                break;
                            case "到库成本":
                                tooltipStr = "销售订单中所产生的到库成本，<br/>不包含多渠道订单到库成本";
                                break;
                            case "FBA配送费":
                                tooltipStr = "销售订单中FBA配送费";
                                break;
                            case "销售佣金":
                                tooltipStr = "销售订单中销售佣金";
                                break;
                            case "退款":
                                tooltipStr = "产生退款的订单中退还给买家的金额";
                                break;
                            case "广告花费":
                                tooltipStr = "广告所产生的费用，<br/>包含商品广告、展示广告费用";
                                break;
                            case "多渠道扣费":
                                tooltipStr = "多渠道订单所产生的费用包括采购成本、<br/>到库成本、其他费用";
                                break;
                            case "推广订单费用":
                                tooltipStr = "标记为推广订单的订单所产<br/>生的推广本金与推广佣金";
                                break;
                            case "其它":
                                tooltipStr = "其他销售相关费用";
                                break;
                            case "仓储费":
                                tooltipStr = "包含FBA月仓储费、<br/>FBA 长期仓储费";
                                break;
                            case "促销折扣":
                                tooltipStr = "促销折扣金额";
                        }
                        return tooltipStr;
                    }
                },
                grid: {
                    left: "0%",
                    right: "0%"
                },
                color: ["#1F6EEF","#F6BD14","#FB6E6C","#9E87FF","#51D351","#1770FC","#F5B700","#FC504D","#8669FE","#1EAA1E",
                    "#5797FB","#F9D567","#FF918F","#A68FFF","#ABFFAB"],
                formatter: function(name) {
                    let className = 'upRate'
                    let rateIcon = '▲'
                    if (data && data.length) {
                        for (var i = 0; i < data.length; i++) {
                            if (name === data[i].name) {
                                if (data[i].rate < 0) {
                                    className = 'downRate'
                                    rateIcon = '▼'
                                }
                                return (
                                    '{name| ' +
                                    name +
                                    '}   ' +
                                    '{value| ' +
                                    data[i].currencySymbol + amount(data[i].averageFee)  +
                                    '} ' +
                                    '{count| ' +
                                    data[i].currencySymbol + amount(data[i].value) +
                                    '} ' +
                                    '{' + className + '| '  +
                                    Math.abs(data[i].rate) +
                                    '%}'
                                )
                            }
                        }
                    }
                }
            },
            series: {
                name: '数量',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['15%', '50%'],
                color: ["#1F6EEF","#F6BD14","#FB6E6C","#9E87FF","#51D351","#1770FC","#F5B700","#FC504D","#8669FE","#1EAA1E",
                    "#5797FB","#F9D567","#FF918F","#A68FFF","#ABFFAB"],
                label: {
                    normal: {
                        show: false,
                        position: 'center',
                        formatter: '{text|{c}}\n{b}',
                        rich: {
                            text: {
                                align: 'center',
                                verticalAlign: 'middle',
                                padding: 8,
                                fontSize: 30
                            },
                            value: {
                                align: 'center',
                                verticalAlign: 'middle',
                                fontSize: 20
                            }
                        }
                    },
                    emphasis: {
                        show: false,
                        textStyle: {
                            fontSize: '12'
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: true
                    }
                }
            }
        }
    }
}

export const generatorPieOneChartsData = (currencySymbol) => {
    return (data) => {
        return {
            tooltip: {
                formatter:function(params){
                    let str = '金额' + "<br/>";
                    str += params.marker + params.data.name + ":&nbsp;&nbsp;" + currencySymbol + amount(params.data.value)
                    return str;
                }
            },
            title: {
                text: '{header1| 费用项}' +
                    '{header2| 平均费用}' +
                    '{header3| 费用}' +
                    '{header4| 费用占比}',
                // textAlign: 'left',
                left: '41%',
                top: '0%',
                right: "0%",
                textStyle: {
                    // color: '#ccc',
                    rich: {
                        header1: {
                            width: 90,
                            fontSize: 14
                        },
                        header2: {
                            width: 85,
                            fontSize: 14
                        },
                        header3: {
                            width: 60,
                            fontSize: 14
                        },
                        header4: {
                            fontSize: 14
                        }
                    }
                }
            },
            legend: {
                // selectedMode: false, // 取消图例上的点击事件
                type: 'plain',
                icon: 'circle',
                orient: 'vertical',
                left: '40%',
                top: '10%',
                right: "0%",
                align: 'left',
                itemGap: 15,
                itemWidth: 10, // 设置宽度
                itemHeight: 10, // 设置高度
                symbolKeepAspect: false,
                textStyle: {
                    width: "100%",
                    color: '#000',
                    rich: {
                        name: {
                            verticalAlign: 'right',
                            align: 'left',
                            width: 90,
                            fontSize: 12
                        },
                        topFloor:{
                            borderTopColor: "#999",
                            borderTopWidth: "1px",
                            color: 'transparent',
                        },
                        extraName:{
                            verticalAlign: 'right',
                            align: 'left',
                            width: 168,
                            fontSize: 12
                        },
                        value: {
                            align: 'left',
                            width: 60,
                            fontSize: 12
                        },
                        count: {
                            align: 'left',
                            width: 70,
                            fontSize: 12
                        },
                        upRate: {
                            align: 'left',
                            fontSize: 12,
                            width: 50,
                            color: '#00cf90'
                        },
                        downRate: {
                            align: 'left',
                            fontSize: 12,
                            width: "100%",
                            color: '#ff5722'
                        }
                    }
                },
                tooltip:{
                    show: true,
                    formatter: (params) => {
                        let name = _.get(params,"name", _.get(params, 'extraName'));
                        let tooltipStr = "";
                        switch (name) {
                            case "销售额":
                                tooltipStr = "商品售价*销量";
                                break;
                            case "平台费":
                                tooltipStr = "包括礼品包装费、 礼品包装税费、其他相关费用";
                                break;
                            case "运费":
                                tooltipStr = "买家支付的运费";
                                break;
                            case "退货补回成本":
                                tooltipStr = "货量*（采购成本+到库成本）+其他退<br/>货所产生的费用";
                                break;
                            case "广告销售额":
                                tooltipStr = "由商品广告、展示广告产生的销售额，<br/>仅做展示，不参与计算";
                                break;
                            case "促销折扣":
                                tooltipStr = "仅做展示，不参与计算";
                                break;
                        }
                        return tooltipStr;
                    }
                },
                grid: {
                    left: "0%",
                    right: "0%"
                },
                color: ["#1F6EEF","#F6BD14","#FB6E6C","#9E87FF","#51D351","#1770FC","#F5B700","#FC504D","#8669FE","#1EAA1E",
                    "#5797FB","#F9D567","#FF918F","#A68FFF","#ABFFAB"],
                formatter: function(name) {
                    let className = 'upRate'
                    let rateIcon = '▲'
                    if (data && data.length) {
                        for (var i = 0; i < data.length; i++) {
                            if (name === data[i].name) {
                                if (data[i].rate < 0) {
                                    className = 'downRate'
                                    rateIcon = '▼'
                                }
                                if(data[i].name === "促销折扣"){
                                    className = 'discountCost';
                                    return (
                                        '{extraName| ' +
                                        name + '}' +
                                        data[i].currencySymbol + amount(data[i].extraValue)
                                    )
                                } else if(data[i].name === "广告销售额"){
                                    className = 'adsSales';
                                    return (
                                        '{extraName| ' +
                                        name + '}' +
                                        data[i].currencySymbol + amount(data[i].extraValue)
                                    )
                                } else {
                                    return (
                                        '{name| ' +
                                        name +
                                        '}   ' +
                                        '{value| ' +
                                        data[i].currencySymbol + amount(data[i].averageFee)  +
                                        '} ' +
                                        '{count| ' +
                                        data[i].currencySymbol + amount(data[i].value) +
                                        '} ' +
                                        Math.abs(data[i].rate) +
                                        '%'
                                    )
                                }
                            }
                        }
                    }
                }
            },
            series: {
                name: '金额',
                type: 'pie',
                radius: ['30%', '60%'],
                center: ['15%', '50%'],
                color: ["#1F6EEF","#F6BD14","#FB6E6C","#9E87FF","#999","#999","#999"],
                label: {
                    normal: {
                        show: false,
                        position: 'center',
                        formatter: '{text|{c}}\n{b}',
                        rich: {
                            text: {
                                align: 'center',
                                verticalAlign: 'middle',
                                padding: 8,
                                fontSize: 30
                            },
                            value: {
                                align: 'center',
                                verticalAlign: 'middle',
                                fontSize: 20
                            }
                        }
                    },
                    emphasis: {
                        show: false,
                        textStyle: {
                            fontSize: '12'
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: true
                    }
                }
            }
        }
    }
}

export const VIEW_ASIN_361_SETTING = () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryData',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryData'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    slot: 'dateRange',
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'DAY'
}, {
    prop: 'asinCode',
    label: 'ASIN',
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: '',
    validator: [
        {required: true, message: '请输入ASIN', trigger: 'change'}
    ],
    slot: 'asinCode'
}, {
    prop: 'asinType',
    defaultValue: 'child'
}, {
    prop: 'startDateTime',
    defaultValue: ''
}, {
    prop: 'endDateTime',
    defaultValue: ''
}]

export const DEFAULT_CHARTS_DATA = {
    data: {
        rows: [],
        columns: []
    },
    settings: {},
    options: {},
    empty: true
}
